import { Component, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
	Validators
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';
import { AuthResponse } from './../interfaces/authUser';
import { StoreService } from '../services/store.service';

@Component({
	selector: 'app-login',
	standalone: true,
	imports: [
		MatFormFieldModule,
		MatInputModule,
		MatIconModule,
		ReactiveFormsModule,
		MatButtonModule,
		FormsModule
	],
	templateUrl: './login.component.html',
	styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
	loginForm: FormGroup = this._fb.group({});

	passwordInputType: string = 'password';
	passwordIcon: string = 'visibility';

	showErrorMessage: boolean = false;

	constructor(
		private _fb: FormBuilder,
		private _router: Router,
		private _navigationService: NavigationService,
		private _authService: AuthService,
		private _storeService: StoreService
	) {}

	ngOnInit(): void {
		this._formBuilder();
	}

	onSubmit(): void {
		if (this.loginForm.invalid) {
			this.loginForm.markAllAsTouched();
			return;
		}
		this.showErrorMessage = false;

		const body = new FormData();
		body.append('username', this.loginForm.get('username')?.value);
		body.append('password', this.loginForm.get('password')?.value);
		this._storeService.toggleLoadingDialog(true);

		this._authService.login(body).subscribe({
			next: (authResponse: AuthResponse) => {
				if (authResponse.response === 'Error') {
					this.showErrorMessage = true;
					this._storeService.toggleLoadingDialog(false);
					return;
				}
				this._storeService.toggleLoadingDialog(false);
				this._router.navigate(['']);
				this._navigationService.emitNextRoute('dashboard', 0);
			},
			error: () => {
				this.showErrorMessage = true;
				this._storeService.toggleLoadingDialog(false);
			}
		});
	}

	changePasswordInputType(): void {
		if (this.passwordInputType === 'password') {
			this.passwordInputType = 'text';
			this.passwordIcon = 'visibility_off';
		} else {
			this.passwordInputType = 'password';
			this.passwordIcon = 'visibility';
		}
	}

	private _formBuilder(): void {
		this.loginForm = this._fb.group({
			username: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(6)]]
		});
	}
}
